/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useContext } from 'react';
import { Card, Icon } from '@scuf/common';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../locales/en-US/descriptors';
import AllUtilitiesDetailsComponent from './AllUtilitiesDetails/AllUtilitiesDetailsComponent';
import ElectricityUtility from './OthersUtilities/ElectricityUtility';
import GasUtility from './OthersUtilities/GasUtility';
import WaterUtility from './OthersUtilities/WaterUtility';
import SewerageUtility from './OthersUtilities/SewerageUtility';
import SharedTabsWidget from '../../shared/SharedTabs/SharedTabs';
import './UtilityBillViewDetailsTheme.scss';
import IEnergyManagementProps, {
  ECartAt
} from '../../DashboardKPIWidgets/IEnergyManagementProps';
import { DataContextProvider } from '@forge/data-connector';
import { ApiContext } from '../../../context/ApiContext';
import SolarSavingsDetailComponent from './SolarSavingsDetail/SolarSavingsDetailComponent';
import WindSavingsDetailComponent from './WindSavingsDetail/WindSavingsDetailComponent';

const UtilityBillViewDetailsComponentContent = (
  props: IEnergyManagementProps
) => {
  const { bearerToken, requestContext, emaasContext } = props;
  const d = descriptors.energyManagement;
  const [t] = useTranslation();
  const apiContext = useContext(ApiContext);
  const { onBacktoDashboardClick } = apiContext;
  const header =
    apiContext.apiCallAt === ECartAt.portfolioLabel
      ? t(d.UTILITYCOSTOVERVIEW)
      : t(d.UtilityCost);
  const onBackarrowClick = () => {
    if (onBacktoDashboardClick) {
      onBacktoDashboardClick();
    }
  };

  const changeActiveIndex = (activeIndex: number) => {
    apiContext.setActiveIndexForUtility &&
      apiContext.setActiveIndexForUtility(activeIndex);
  };

  const displayTabs = {
    displayTabs: [
      {
        className: 'emaas-utility-view-details-all-utilities',
        title: t(d.ALLUTILITIES),
        component: AllUtilitiesDetailsComponent
      },
      {
        className: 'emaas-utility-view-details-electricity',
        title: t(d.Electricity),
        component: ElectricityUtility
      },
      {
        className: 'emaas-utility-view-details-gas',
        title: t(d.Gas),
        component: GasUtility
      },
      {
        className: 'emaas-utility-view-details-water',
        title: t(d.Water),
        component: WaterUtility
      },
      {
        className: 'emaas-utility-view-details-sewerage',
        title: t(d.Sewerage),
        component: SewerageUtility
      }
    ],
    bearerToken,
    requestContext,
    emaasContext,
    ActiveIndex: apiContext?.ActiveIndex,
    forPortfolio: apiContext?.apiCallAt === ECartAt.portfolioLabel
  };

  if (apiContext.MultilabelBreakdown) {
    const solarTabs = {
      className: 'emaas-utility-view-details-solar',
      title: t(d.SOLAR),
      component: SolarSavingsDetailComponent
    };
    const windTabs = {
      className: 'emaas-utility-view-details-wind',
      title: t(d.WIND),
      component: WindSavingsDetailComponent
    };
    displayTabs.displayTabs.push(solarTabs, windTabs);
  }
  return (
    <div className="emaas-utility-container-kpi-card-common">
      <Card>
        <Card.Header className="emaas-utility-bill-viewDetails-kpi-header-container">
          <div className="emaas-utility-bill-viewDetails-kpi-card-title">
            <span className="utility-bill-backButton">
              <Icon
                root="common"
                name="arrow-left"
                size="medium"
                onClick={() => onBackarrowClick()}
              />
            </span>
            {header}
          </div>
        </Card.Header>
        <Card.Content className="emaas-utility-bill-viewDetails-kpi-content-container">
          <DataContextProvider config={props.connectorConfig}>
            <SharedTabsWidget
              onTabChange={(activeIndex: number) => {
                changeActiveIndex(activeIndex);
                console.log('activeIndex  isss', activeIndex);
              }}
              {...displayTabs}
            />
          </DataContextProvider>
        </Card.Content>
      </Card>
    </div>
  );
};

export default UtilityBillViewDetailsComponentContent;
